import * as React from "react";
import CommonStreamItem from "../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import AccountingNote from "../../../model/invoice/note/AccountingNote";
import {default as BillActivityNoteItem} from "./items/BillActivityNoteItem";
import Payment from "../../../model/payment/Payment";
import {BillActivityPaymentItem} from "./items/BillActivityPaymentItem";
import {BillActivityItemsType} from "./BillActivityStream";
import BillUpdatedEvent from "../../../model/bill/event/BillUpdatedEvent";
import {AccountingCommonActivityUpdatedItem} from "../activityStream/items/AccountingCommonActivityUpdatedItem";

interface ComponentProps {
	/**
	 * Bill activity data.
	 */
	activityItems: BillActivityItemsType[];
	/**
	 * Note id to set active class and focus on it.
	 */
	activeNoteId: string;
	/**
	 * Edit note click action.
	 * @param note note to edit.
	 */
	onEditNoteClick: (note: AccountingNote) => void;
	/**
	 * Delete note success callback.
	 * @param note deleted note.
	 */
	onDeleteNoteSuccess: (note: AccountingNote) => void;
}

type Props = ComponentProps;

/**
 * BillActivityStreamItems component
 */
export default class BillActivityStreamItems extends React.PureComponent<Props, {}> {
	render() {
		return this.props.activityItems.map((activity, index) => {
			return (
				<div className="c-common-details_activity-stream-item-container" key={index}>
					{this.renderItem(activity)}
				</div>
			);
		})
	}

	renderItem = (activity: BillActivityItemsType) => {
		if (activity instanceof AccountingNote) {
			return <BillActivityNoteItem activity={activity}
										 isActive={this.isActive(activity.id)}
										 onEditNoteClick={this.props.onEditNoteClick}
										 onDeleteNoteSuccess={this.props.onDeleteNoteSuccess}/>;
		}
		if (activity instanceof BillUpdatedEvent) {
			return <AccountingCommonActivityUpdatedItem activity={activity}/>;
		}
		if (activity instanceof Payment) {
			return <BillActivityPaymentItem activity={activity}/>;
		}
		return <CommonStreamItem event={activity}/>;
	};

	/**
	 * Check if note is the active one.
	 */
	isActive = (noteId: string): boolean => {
		return this.props.activeNoteId === noteId;
	};
}
